import { Component, OnInit, ViewChild,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Subject } from 'rxjs/Subject';
import { Http, Response,Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { DataTableDirective } from 'angular-datatables';
import {MatSnackBar} from '@angular/material';
import { NgForm } from '@angular/forms';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import {SnackbarComponent} from '../snackbar/snackbar.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css'],
   providers: [HelperService] 
})
export class UsersComponent implements OnInit {
  @HostListener('window:beforeunload', ['$event'])
	unloadHandler(event: Event) {
	localStorage.removeItem('access_token');
	localStorage.removeItem('navigateroute');
  }
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  datas:any=[];
  dtElement: DataTableDirective;

  list=true;
  edit=false;
  add=false;

  icon=this.helper.add_icon;
  icon_action='addClick';
  user_email='';
  user_id=0;
  user_role_id;
  roles;
  user_permissions:any=[];
  user_name='';
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
status;
  constructor(private cookie:CookieService,private helper:HelperService,private http:Http,private snackbar: MatSnackBar,private router: Router) {
  }

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
  	this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10
    };
    
    this.http.get(this.helper.base_url+'http/get/users',{ headers: this.headers })
    
    .subscribe(data => {
      this.datas = JSON.parse(data['_body']).users;
       this.roles = JSON.parse(data['_body']).roles;
        this.dtTrigger.next();
     
    });
  }

  editClick(data){
    
    this.list=false;
    this.edit=true;
    this.add=false;
    this.icon=this.helper.list_icon;
    this.icon_action="listClick";
    this.user_email=data.email;
    this.user_id=data.id;
    this.user_role_id=data.role_id;
    this.user_name=data.name;
    this.status = data.status;
  }
  addClick(e){
    
    this.list=false;
    this.edit=false;
    this.add=true;
    this.icon=this.helper.list_icon;
    
    this.icon_action="listClick";
  }
  listClick(e){
    this.list=true;
    this.edit=false;
    this.add=false;
    this.icon=this.helper.add_icon;
    this.icon_action="addClick";
  }
  add_form(addForm: NgForm){
  
  let body = new FormData();
  body.append('name', addForm.value.name);
  body.append('email', addForm.value.email);
  body.append('password', addForm.value.password);
  body.append('role_id', addForm.value.role_id);

 this.http.get(this.helper.base_url+'http/check/user?email='+addForm.value.email,{ headers: this.headers })
   .subscribe(
     (res) => {
       let user=res['_body'];
       user=JSON.parse(user);
     //  console.log(user.length);
if (user.length == 0) {

      this.http.post(this.helper.base_url+'http/add/user', body,{ headers: this.headers })
     .subscribe(
     (res) => {
      this.listClick(null) ;
      this.refresh(false,'User added successfully') ;
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
   }else{

     this.snackbar.open('User already exist', null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
   }
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );

  
 }
 update_form(addForm: NgForm){
  let body = new FormData();
  body.append('name', addForm.value.name);
  body.append('email', addForm.value.email);
  body.append('passwordp', addForm.value.password);
  body.append('role_id', addForm.value.role_id);
  body.append('status', addForm.value.status);
  //body.append('user_id', this.cookie.get('user_id'));
  
   this.http.post(this.helper.base_url+'http/update/user/'+this.user_id, body,{ headers: this.headers })
   .subscribe(
     (res) => {
     let  data=JSON.parse(res['_body']);
    if(!data.error){
       this.listClick(null) ;
      this.refresh(false,'User updated successfully') ;
    }else{
       this.listClick(null) ;
      this.error_refresh(false,data.message) ;
    }
     
     }, //For Success Response
      err => {console.error(err)} //For Error Response);
   );
 }
 delete_form(id){
        
  let snackBarRef = this.snackbar.openFromComponent(SnackbarComponent, {
    //this.snackbar.open('Are you sure!', 'Delete', {
      duration: 5000,
      extraClasses:  ['warning-snackbar'],
    }).onAction().subscribe(() => {
      this.http.get(this.helper.base_url+'http/delete/user/'+id,{ headers: this.headers })
      .subscribe(
         
          (data) => this.refresh(false,'User Removed successfully'), //For Success Response
          err => {console.error(err)} //For Error Response
      ); 
    });
   
  }
  refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/users"]));
  
      
 }
 error_refresh(val=false,msg=''){
  this.snackbar.open(msg, null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["/users"]));
  
      
 }


}



// WEBPACK FOOTER //
// ./src/app/users/users.component.ts